import {createSelector} from "@reduxjs/toolkit";

export function selectUser() {
  return createSelector(s => s.accessControlSession.user);
}
